import methods from '@/services/methods'

export default {
  profileDetails () {
    return methods.sendGet(`user_profile`)
  },
  enableEmailSubscription (payload) {
    return methods.sendPost(`user_profile/enable_subscription`, payload, {disableButtons: true})
  },
  disableEmailSubscription (payload) {
    return methods.sendPost(`user_profile/disable_subscription`, payload, {disableButtons: true})
  },
  updateDetails (payload) {
    return methods.sendPost(`user_profile/update_details`, payload)
  },
  changePassword (payload) {
    return methods.sendPost(`user_profile/change_password`, payload, {restrictToast: true, disableButtons: true})
  },
  enable2FA () {
    return methods.sendPost(`user_profile/enable_two_factor`)
  },
  disable2FA () {
    return methods.sendPost(`user_profile/disable_two_factor`)
  },
  reset2FA () {
    return methods.sendPost(`user_profile/reset_two_factor`)
  },
  destroySession (payload) {
    return methods.sendDelete(`user_profile/destroy_session`, payload)
  }
}
